import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { useDrawerLayoutContext } from "../../-DrawerLayoutContext";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useEffect } from "react";
import { PageHeader } from "@dmca/frontend/components/nav";
import { checkPermissionsInLoader } from "@dmca/frontend/hooks";

export const Route = createFileRoute("/_authed/_drawerLayout/admin/user")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { qc, trpcQcProxy: trpc } = context;
    await checkPermissionsInLoader("Admin::UpdateUser", context);
    qc.prefetchQuery(trpc.user.getAll.queryOptions());
  },
  head: () => ({
    meta: [
      {
        title: "Manage Users | DNA Dashboard",
      },
    ],
  }),
});

function RouteComponent() {
  const { trpcQcProxy: trpc } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const id = useMatches({
    select: (matches) => {
      const match = matches[matches.length - 1];
      return (match.params as any)?.id as string;
    },
  });
  const { data: users, isLoading } = useQuery(trpc.user.getAll.queryOptions());
  const parsedUsers = useMemo(
    () =>
      users
        ?.map((x) => ({
          label: x.name,
          secondary: `User ID: ${x.id}`,
          value: x.id,
        }))
        .sort(
          (x, y) =>
            x.label.localeCompare(y.label) || x.value.localeCompare(y.value)
        ) ?? [],
    [users]
  );
  const {
    selectedItem: [, setSelectedItem],
  } = useDrawerLayoutContext({
    listItems: parsedUsers,
    isLoading,
    onItemSelected: (item: { label: string; value: string }) => {
      navigate({
        to: "/admin/user/$id",
        params: {
          id: item.value,
        },
      });
    },
  });

  useEffect(() => {
    const selected = parsedUsers.find((x) => x.value === id);
    setSelectedItem(selected);
  }, [id, parsedUsers, setSelectedItem]);
  return (
    <>
      <PageHeader>Manage Users</PageHeader>
      <Outlet />
    </>
  );
}
